// extracted by mini-css-extract-plugin
export var option = "_8x-0";
export var optionCard = "_8x-f";
export var optionContent = "_8x-g";
export var optionIcon = "_8x-i";
export var optionIconBox = "_8x-h";
export var optionLabel = "_8x-j";
export var optionPill = "_8x-m";
export var optionPillBadge = "_8x-p";
export var optionPillIcon = "_8x-n";
export var optionPillLabel = "_8x-o";
export var optionRadio = "_8x-k";
export var optionRadioInner = "_8x-l";
export var optionReveal = "_8x-2";
export var optionRevealDelay0 = "_8x-3";
export var optionRevealDelay1 = "_8x-4";
export var optionRevealDelay10 = "_8x-d";
export var optionRevealDelay11 = "_8x-e";
export var optionRevealDelay2 = "_8x-5";
export var optionRevealDelay3 = "_8x-6";
export var optionRevealDelay4 = "_8x-7";
export var optionRevealDelay5 = "_8x-8";
export var optionRevealDelay6 = "_8x-9";
export var optionRevealDelay7 = "_8x-a";
export var optionRevealDelay8 = "_8x-b";
export var optionRevealDelay9 = "_8x-c";
export var optionSelected = "_8x-1";